import { KendoBaseComponent } from '@progress/kendo-base-components-vue-wrapper'
import RadialGaugeProps from './RadialGaugeProps'
import KendoRadialGaugePointer from './KendoRadialGaugePointer'

import GaugeArea from '../Common/GaugeArea'
import Scale from './Scale'

export default {
    props: RadialGaugeProps,
    emits: {
        'kendowidgetready': null
    },
    mixins: [
        KendoBaseComponent,
        GaugeArea,
        Scale
    ],
    mounted() {
        this._resolveChildren()

        kendo.jQuery(this.$el).kendoRadialGauge(this.widgetOptions)

        if(this.v3) {
            this.ready()
            this.$emit('kendowidgetready', this.kendoWidget())
        } else {
            this.$emit('kendowidgetready', this.kendoWidget())
        }
    },
    methods: {
        kendoWidget() {
            return kendo.jQuery(this.$el).getKendoRadialGauge()
        },
        _resolveChildren() {
            this.resolveChildren('pointer', KendoRadialGaugePointer.name)
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-gauges-vue-wrapper/src/KendoRadialGauge/KendoRadialGaugeMixin.js